module.exports = __webpack_public_path__ + "static/media/levain_bg_img_6.64987727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/levain_bg_img_6.jpg
// module id = 1061
// module chunks = 0